module.exports = __webpack_public_path__ + "img/visual-dashboard.d710e7fc.png";